import { ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { KGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/kgrid.component";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { SplashFormService } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/Splash-form.service";
import { EntityListAction, form_control, Permission } from "projects/sepidz-web-framework/src/lib/models";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { NameValue } from "projects/sepidz-web-framework/src/lib/models/name-value";
import { GridFilter, LookupService, Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { HrmPayCurentYearMonthComponent } from "../../hrm-pay-curent-year-month/hrm-pay-curent-year-month.component";
import { HRNotificationHeader } from "../../models/hrnotification-header.model";
import { HrmAccVoucherDateFormComponent } from "./hrm-acc-voucher-date/hrm-acc-voucher-date-form.component";

@Component({
  selector: "hrm-acc-voucher",
  templateUrl: "./hrm-acc-voucher.component.html",
  styleUrls: ["./hrm-acc-voucher.component.scss"],
})
export class HrmAccVoucherComponent extends BaseListComponent {
  loadingIndicator: boolean;
  inputEditorform: any;
  editingName: { name: string };
  actions: EntityListAction[];
  PayCompaniesIds: number[] = [];
  public HrmAccVoucherColimns: form_control[] = [];
  model: any;
  filterInfo: NameValue[] = [];
  @ViewChild(KGridComponent) grid: KGridComponent;
  constructor(private splashFormService: SplashFormService, private cd: ChangeDetectorRef, private lookupservice: LookupService) {
    super();
    this.onActionClick = this.onActionClick.bind(this);
  }
  ngOnInit() {
    this.apiName = "HrmAccVoucherCode/GetAccVoucherInfo";
    this.areaName = "Payroll";
    this.label = "صدور سند حسابداری";
    this.setColumns();
    this.setactions();
    if (this.accountService.authService.getHrmPayCurentYearMonth()) {
      if (
        this.accountService.authService.getHrmPayCurentYearMonth().CurentYear &&
        this.accountService.authService.getHrmPayCurentYearMonth().CurentMonth
      ) {
        this.filterInfo.push({ Name: "IssueYear", Value: this.accountService.authService.getHrmPayCurentYearMonth().CurentYear, Operator: "eq" });
        this.filterInfo.push({ Name: "IssueMonth", Value: this.accountService.authService.getHrmPayCurentYearMonth().CurentMonth, Operator: "eq" });
      }
    } else this.setHrmPayCurentYearMonth();
  }
  setColumns() {
    let group: any = {};
    this.model = {};
    this.model.IssueYear = this.accountService.authService.getHrmPayCurentYearMonth().CurentYear;
    this.model.IssueMonth = this.accountService.authService.getHrmPayCurentYearMonth().CurentMonth;
    this.columns = [];
    this.columns.push(<form_control>{
      label: "نوع سند",
      controlType: FormControlTypes.dropdown,
      modelName: "HrmVouchrKindId",
      disabled: false,
      name: "HrmVouchrKindId",
      order: 1,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: true,
      columnNumber: 1,
      userClass: "select-sm",
      apiName: "Lookup",
      systemName: "HRM",
      category: "HrmVouchrKind",
      valueMember: "Id",
      displayMember: "Title",
    });
    this.columns.push(<form_control>{
      label: "سال",
      controlType: FormControlTypes.dropdown,
      modelName: "IssueYear",
      disabled: false,
      name: "IssueYear",
      order: 0,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: true,
      columnNumber: 1,
      userClass: "select-sm",
      apiName: "FiscalYear/FiscalYear",
      valueMember: "Year",
      displayMember: "Year",
    });
    this.columns.push(<form_control>{
      label: "ماه",
      controlType: FormControlTypes.dropdown,
      modelName: "IssueMonth",
      disabled: false,
      name: "IssueMonth",
      order: 1,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: true,
      columnNumber: 2,
      userClass: "select-sm",
      apiName: "MonthsName",
      valueMember: "Id",
      displayMember: "Title",
    });

    group["IssueYear"] = new UntypedFormControl(this.model.IssueYear, Validators.required);
    group["IssueMonth"] = new UntypedFormControl(this.model.IssueMonth, Validators.required);
    this.lookupservice
      .getLookupbyCode("HRM", "HrmVouchrKind", 1)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((rk) => {
        this.filterInfo.push({ Name: "HrmVouchrKindId", Value: rk.Id, Operator: "eq" });
        this.filterInfo.push({ Name: "HrmVouchrKindCode", Value: rk.Code, Operator: "eq" });
        group["HrmVouchrKindId"] = new UntypedFormControl(rk.Id, Validators.required);
      });
    this.group = new UntypedFormGroup(group);
    this.model = this.getDataFromFormGroup(this.model);
    this.httpCommonService
      .getList("HrmAccVoucherCode/GetHrmAccVoucherColimns")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (x) => {
          this.HrmAccVoucherColimns = x as [];
        },
        (error) => {
          console.timeLog(error);
        }
      );
  }
  onActionClick(
    action: EntityListAction,
    onRowSelected: HRNotificationHeader,
    onRowsSelected: HRNotificationHeader[],
    isAllSelected: boolean,
    gridFilter: GridFilter[]
  ) {
    let skip = gridFilter[0]?.Skip ?? 0;
    let take = gridFilter[0]?.Take ?? 10;
    if (isAllSelected) {
      gridFilter.push({ Filed: "IsAllSelected", Operator: "eq", Type: "F", Skip: skip, Take: take, Value: isAllSelected, Logic: "and" });
    } else if (onRowsSelected && onRowsSelected.length > 0) {
      let PersonnelIds: number[] = [];
      onRowsSelected.forEach((x) => {
        if (PersonnelIds.some((s) => s === x.HrmPersonnelId)) PersonnelIds.push(x.HrmPersonnelId);
      });
      if (!gridFilter.some((s) => s.Filed === "PersonnelIds"))
        gridFilter.push({ Filed: "PersonnelIds", Operator: "eq", Type: "F", Skip: skip, Take: take, Value: PersonnelIds, Logic: "and" });
      else gridFilter.find((s) => s.Filed === "PersonnelIds").Value = PersonnelIds;
    } else if (onRowSelected) {
      let PersonnelIds: number[] = [];
      PersonnelIds.push(onRowSelected.HrmPersonnelId);
      gridFilter.push({ Filed: "PersonnelIds", Operator: "eq", Type: "F", Skip: skip, Take: take, Value: PersonnelIds, Logic: "and" });
    }
    this.inputEditorform = HrmAccVoucherDateFormComponent;
    this.dialogService
      .open(
        this.inputEditorform,
        {
          currentrow: null,
          apiName: this.apiName,
          areaName: this.areaName,
          label: this.label,
        },
        {
          autoFocus: true,
          closeOnClickOutside: false,
          closeOnEscape: false,
        }
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((model) => {
        this.splashFormService.openDialog("", "در حال صدور سند حسابداری");
        if (!gridFilter.some((s) => s.Filed === "FiscalYearId"))
          gridFilter.push({
            Filed: "FiscalYearId",
            Operator: "eq",
            Type: "F",
            Skip: skip,
            Take: take,
            Value: this.accountService.authService.currentFiscalYear.Id,
            Logic: "and",
          });
        else gridFilter.find((s) => s.Filed === "FiscalYearId").Value = this.accountService.authService.currentFiscalYear.Id;

        if (!gridFilter.some((s) => s.Filed === "VoucherDate"))
          gridFilter.push({ Filed: "VoucherDate", Operator: "eq", Type: "F", Skip: skip, Take: take, Value: model["VoucherDate"], Logic: "and" });
        else gridFilter.find((s) => s.Filed === "VoucherDate").Value = model["VoucherDate"];

        if (!gridFilter.some((s) => s.Filed === "BranchId"))
          gridFilter.push({ Filed: "BranchId", Operator: "eq", Type: "F", Skip: skip, Take: take, Value: model["BranchId"], Logic: "and" });
        else gridFilter.find((s) => s.Filed === "BranchId").Value = model["BranchId"];

        this.httpCommonService
          .create(action.apiName, gridFilter)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(
            (x) => {
              this.sts.showDialog("سند با موفقیت صادر شد.", "");
              this.splashFormService.closeLoading();
            },
            (error) => {
              this.splashFormService.closeLoading();
              this.sts.showDialog(` خطا در صدور سند حسابداری${Utilities.getHttpResponseMessage(error)}`, "خطا");
            }
          );
      });
  }
  setHrmPayCurentYearMonth() {
    this.dialogService
      .open(
        HrmPayCurentYearMonthComponent,
        {
          areaName: this.areaName,
          label: this.label,
        },
        {
          autoFocus: true,
          closeOnClickOutside: false,
          closeOnEscape: false,
        }
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((model) => {
        this.ngOnInit();
      });
  }
  onvalueChangeByApiName($event) {
    if ($event.apiName && $event.data && $event.data.Id && $event.apiName.includes("Lookup") && $event.KeyName === "HrmVouchrKindId") {
      this.filterInfo.find((x) => x.Name === "HrmVouchrKindId").Value = $event.data.Id;
      this.filterInfo.find((x) => x.Name === "HrmVouchrKindCode").Value = $event.data.Code;
      if (this.grid) this.grid.defaultFilterKey = this.filterInfo;
      this.cd.markForCheck();
    }
    if ($event.apiName && $event.data && $event.data.Id && $event.apiName.includes("FiscalYear/FiscalYear") && $event.KeyName === "IssueYear") {
      this.filterInfo.find((x) => x.Name === "IssueYear").Value = $event.data.Id;
      if (this.grid) this.grid.defaultFilterKey = this.filterInfo;
      this.cd.markForCheck();
    }
    if ($event.apiName && $event.data && $event.data.Id && $event.apiName.includes("MonthsName") && $event.KeyName === "IssueMonth") {
      this.filterInfo.find((x) => x.Name === "IssueMonth").Value = $event.data.Id;
      if (this.grid) this.grid.defaultFilterKey = this.filterInfo;
      this.cd.markForCheck();
    }
  }
  setactions() {
    this.actions = [
      {
        name: "MakeAccVoucher",
        disabled: false,
        displayName: "صدور سند",
        iconName: "icon-preview-f",
        apiName: "HrmAccVoucherCode/MakeAccVoucher",
        areaName: "Payroll",
        permission: Permission.samePermission,
      },
    ];
  }
}
